import Vue from 'vue'

// axios
import axios from 'axios'

// En desarrollo la API usa el MISMO host desde el que se abre la app
// (localhost en el PC, o la IP de la red local en el móvil/iPad).
const baseURL = process.env.NODE_ENV === 'production'
    ? 'https://harber.synology.me:8443'
    : `http://${window.location.hostname}:3051`

const axiosIns = axios.create({
    baseURL,
})

Vue.prototype.$http = axiosIns

export default axiosIns
